var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57119 6.12605C6.50802 6.15978 6.4375 6.17742 6.36589 6.17742C6.29427 6.17742 6.22375 6.15978 6.16058 6.12605L0.699219 3.21338V7.51961C0.699911 8.0883 0.926129 8.6335 1.32825 9.03563C1.73038 9.43775 2.27558 9.66397 2.84427 9.66466H9.8875C10.4562 9.66397 11.0014 9.43775 11.4035 9.03563C11.8056 8.6335 12.0319 8.0883 12.0326 7.51961V3.21338L6.57119 6.12605Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36479 5.24875L11.9465 2.27201C11.8342 1.89076 11.6019 1.55594 11.284 1.31734C10.9662 1.07875 10.5798 0.949122 10.1824 0.947754H2.84318C2.41305 0.948595 1.99312 1.07878 1.63795 1.32139C1.28278 1.564 1.00878 1.90783 0.851562 2.30819L6.36479 5.24875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ac29a0a4cc2ffe27bb6964918c143fef.svg";
export { ForwardRef as ReactComponent };